/* tslint:disable */
/* eslint-disable */
/**
 * crm
 * crm
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ApfmFinancialResponse
 */
export interface ApfmFinancialResponse {
    /**
     * 
     * @type {string}
     * @memberof ApfmFinancialResponse
     */
    profile_budget?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ApfmFinancialResponse
     */
    profile_alternate_funding_types?: Array<string>;
}

/**
 * Check if a given object implements the ApfmFinancialResponse interface.
 */
export function instanceOfApfmFinancialResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ApfmFinancialResponseFromJSON(json: any): ApfmFinancialResponse {
    return ApfmFinancialResponseFromJSONTyped(json, false);
}

export function ApfmFinancialResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApfmFinancialResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'profile_budget': !exists(json, 'profile_budget') ? undefined : json['profile_budget'],
        'profile_alternate_funding_types': !exists(json, 'profile_alternate_funding_types') ? undefined : json['profile_alternate_funding_types'],
    };
}

export function ApfmFinancialResponseToJSON(value?: ApfmFinancialResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'profile_budget': value.profile_budget,
        'profile_alternate_funding_types': value.profile_alternate_funding_types,
    };
}

